<script>
import { getSitemapEntry } from '../utils'

export default {
  props: {
    value: Object,
    scope: Object,
  },
  data() {
    return {
      title: this.$t('deletedUnit'),
      url: '#',
    }
  },
  created() {
    getSitemapEntry(this.scope, this.value.data.residential).then(entry => {
      if (!entry) return
      this.title = entry.pagetitle
      this.url = entry.url
    })
  },
}
</script>

<template>
  <i18n :path="value.event" tag="div">
    <template #residential>
      <a :href="url" target="_blank">{{ title }}</a>
    </template>
  </i18n>
</template>
